import React, { useEffect } from 'react';
import useEditorStore from '../../stores/useEditorStore';
import { useShallow } from 'zustand/shallow';
import { AxisColors } from '../../constants/axisConfig';
import changeCameraDirection, { CameraDirection } from '../../utils/CameraTransformValues';

const MovementToolCard = () => {
  const [showLasers, currentView, setToolSetting] = useEditorStore(
    useShallow((state) => [
      state.toolSettings.scan_axes_movement?.showLasers || false,
      state.toolSettings.scan_axes_movement?.currentView || 'face',
      state.setToolSetting
    ])
  );

  const views = [
    { id: 'face', label: 'View Face', color: AxisColors.Z, direction: CameraDirection.FRONT },
    { id: 'top', label: 'View Top', color: AxisColors.Y, direction: CameraDirection.UPPER },
    { id: 'external', label: 'View External', color: AxisColors.X, direction: CameraDirection.MID }
  ];

  const onToolClick = (viewId) => {
    setToolSetting('scan_axes_movement', 'currentView', viewId);
    let camDirection = views.find(v => v.id === viewId).direction;
    changeCameraDirection(camDirection);
  }

  return (
    <div style={{
      position: 'absolute',
      top: '10px',
      left: '10px',
      background: 'rgba(255, 255, 255, 0.95)',
      borderRadius: '8px',
      padding: '16px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      minWidth: '200px',
      zIndex: 1000
    }}>
      {/* Show Lasers Toggle */}
      <div style={{ marginBottom: '16px' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center'
        }}>
          <div style={{
            position: 'relative',
            marginRight: '12px'
          }}>
            <input
              type="checkbox"
              id="showLasers"
              checked={showLasers}
              onChange={(e) => setToolSetting('scan_axes_movement', 'showLasers', e.target.checked)}
              style={{
                opacity: 0,
                width: 0,
                height: 0
              }}
            />
            <label
              htmlFor="showLasers"
              style={{
                position: 'relative',
                display: 'inline-block',
                width: '44px',
                height: '24px',
                backgroundColor: showLasers ? '#7c3aed' : '#6b7280',
                borderRadius: '12px',
                cursor: 'pointer',
                transition: 'background-color 0.2s ease'
              }}
            >
              <span style={{
                position: 'absolute',
                top: '2px',
                left: showLasers ? '22px' : '2px',
                width: '20px',
                height: '20px',
                backgroundColor: 'white',
                borderRadius: '50%',
                transition: 'transform 0.2s ease',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)'
              }} />
            </label>
          </div>
          <span style={{
            color: '#7c3aed',
            fontWeight: '500',
            fontSize: '14px'
          }}>
            Show Lasers
          </span>
        </div>
      </div>

      {/* View Selection Buttons */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {views.map((view) => (
          <button
            key={view.id}
            onClick={() => onToolClick(view.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '12px 16px',
              border: '1px solid #7c3aed',
              borderRadius: '6px',
              background: currentView === view.id ? '#7c3aed' : '#fff',
              color: currentView === view.id ? '#fff' : '#7c3aed',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              transition: 'all 0.2s ease',
              width: '100%',
              textAlign: 'left'
            }}
            onMouseOver={(e) => {
              if (currentView !== view.id) {
                e.target.style.background = '#f9fafb';
                e.target.style.borderColor = '#d1d5db';
              }
            }}
            onMouseOut={(e) => {
              if (currentView !== view.id) {
                e.target.style.background = '#fff';
                e.target.style.borderColor = '#e5e7eb';
              }
            }}
          >
            <div style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: view.color,
              marginRight: '12px',
              flexShrink: 0
            }} />
            {view.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MovementToolCard; 